interface IStarterPackScenarioActionState {
    action?: string;
    status?: string;
}

export function canDisableStarterPackScenario(
    scenario: IStarterPackScenarioActionState,
): boolean {
    return scenario?.status === "active" && scenario?.action !== "redirect";
}
